var products = function () {
    var pricingNotesCache = {
        partNumbers: {},
        productIds: {}
    };
    var stockNotesCache = {
        partNumbers: {},
        productIds: {}
    };
    var vehicleActivatedPromise = jQuery.Deferred();
    var currentVehicleFitmentProfile;
    
    var iconDefinitions = [
        {
            icon: 'icon-conical-seat',
            match: function (selection) { return ["Conical", "Tapered", "Acorn"].indexOf(selection["Lug Seat"]) >= 0; }
        },
        {
            icon: 'icon-radius-seat',
            match: function (selection) { return ["Radius", "Ball", "Spehrical"].indexOf(selection["Lug Seat"]) >= 0; }
        },
        {
            icon: 'icon-flat-seat',
            match: function (selection) { return ["Flat", "Washer"].indexOf(selection["Lug Seat"]) >= 0; }
        },
        {
            icon: 'icon-oehub',
            match: function (selection) {
                var wheelCenterbore = selection["Centerbore"];
                var oeDirectFitHubTolerance = 0.75;

                if (currentVehicleFitmentProfile) {
                    for (var i = 0; i < currentVehicleFitmentProfile.RangesFront.length; i++) {
                        var fitmentRange = currentVehicleFitmentProfile.RangesFront[i];
                        var hub = parseFloat(fitmentRange.VehicleFitmentHub);

                        if (wheelCenterbore >= hub && wheelCenterbore <= hub + oeDirectFitHubTolerance) {
                            return true;
                        }
                    }

                    for (var i = 0; i < currentVehicleFitmentProfile.RangesRear.length; i++) {
                        var fitmentRange = currentVehicleFitmentProfile.RangesRear[i];
                        var hub = parseFloat(fitmentRange.VehicleFitmentHub);
                        
                        if (wheelCenterbore >= hub && wheelCenterbore <= hub + oeDirectFitHubTolerance) {
                            return true;
                        }
                    }
                }

                return false;
            }
        }
    ];

    initialize($(document.body));

    $(document.body).on('vehicle-activated', function (e, /** @type {VehicleSelectionData} */ vehicleSelection, vehicleDescription, fitmentProfile) {
        currentVehicleFitmentProfile = fitmentProfile;
        vehicleActivatedPromise.resolve(vehicleSelection, vehicleDescription, fitmentProfile);
    });

    return {
        initialize: initialize,

        activate: function (product) {
            var event = $.Event('product-activated');

            event.product = product;
            
            $(document.body).trigger(event, [product]);
        },

        getCart: function (callback, errorCallback) {
            $.ajax({ 
                cache: false,
                url: '/RideStyler/Cart',
                type: 'post',
                success: callback,
                error: errorCallback
            });
        },

        /**
         * @typedef {Object.<string, string>} AddToCartOptions
         * @prop {string}  [productId]                        The ID of the product to add to the cart
         * @prop {string}  [partNumber]                       The part number of the product or combination to add to the cart
         * @prop {string} [shoppingCartTypeId=1]              The type of shopping cart to add it to, 1 specifies the shopping cart, 2 specifies the wishlist
         * @prop {boolean} [showConfirmationModal=true]       If true, show a confirmation modal after adding the product to the cart
         * @prop {number}  [quantity]                         How many to add to the cart
         * @prop {any}     [data]                             Additional data to send along with the request
         */

        /**
         * Adds a product to the cart
         * @param {AddToCartOptions} addToCartOptionsOrForm Options or the form to submit to the addtocart endpoint
         * @param {(addToCartResponse, getCartResponse?)=>void} callback A function to call, after adding the product to the cart. This is ignored if a redirect is requested
         * @param {(error)=>void} errorCallback      A function to call with the response that triggered the error
         */
        addToCart: function (addToCartOptions, callback, errorCallback) {
            /**
             * The url to make the request to
             * @type {string}
             */
            var endpoint;

            /**
             * @type {AddToCartOptions}
             */
            var options = {
                showAttributeSelectionModal: true,
                showConfirmationModal: true
            };

            /**
             * The data to submit to the add to cart endpoint
             */
            var data;

            var productId;

            var deferred = $.Deferred();

            if (typeof errorCallback === 'undefined') {
                errorCallback = function (response) {
                    var msg = response.message;

                    if (typeof msg !== 'string' && msg.length) {
                        msg = msg.join(", ");
                    }

                    displayPopupNotification("<strong>There was an error adding the product to your cart</strong>: " + msg, "error");
                }
            }

            $.extend(options, addToCartOptions);

            var shoppingCartTypeId = parseInt(addToCartOptions.shoppingCartTypeId, 10);

            if (isNaN(shoppingCartTypeId)) shoppingCartTypeId = 1;

            productId = addToCartOptions.productId;
            endpoint = "/AddToCart";

            data = $.extend({
                shoppingCartType: shoppingCartTypeId,
                productId: productId,
                partNumber: addToCartOptions.partNumber,
                quantity: addToCartOptions.quantity || 1
            }, addToCartOptions.data);

            $.ajax({
                cache: false,
                url: endpoint,
                data: data,
                type: 'post',
                success: function (addToCartResponse) {
                    if (addToCartResponse.success) {
                        //success

                        products.getCart(
                            // callback
                            function (getCartResponse) {

                                if ('TotalProducts' in getCartResponse)
                                    updateCartQuantity(getCartResponse.TotalProducts);

                                if (options.showConfirmationModal) {
                                    var items = getCartResponse.Items;
                                    
                                    var matchingShoppingCartItems = [];

                                    // Find all of the shopping cart items matching the product ID
                                    for (var i = 0; i < items.length; i++)
                                        if (items[i].ProductId == productId)
                                            matchingShoppingCartItems.push(items[i]);

                                    // Sort them by most recently added to the cart
                                    matchingShoppingCartItems.sort(function (a, b) {
                                        a = Date.parse(a.UpdatedOnUtc);
                                        b = Date.parse(b.UpdatedOnUtc);

                                        if (a > b) return -1;
                                        if (b > a) return 1;

                                        return 0;
                                    });

                                    if (matchingShoppingCartItems.length) modal.fromURL('/AddedToCartPopup/' + matchingShoppingCartItems[0].Id);
                                }

                                if (typeof callback === 'function') callback(addToCartResponse, getCartResponse);
                                deferred.resolve();
                            },

                            // errorCallback
                            function() {
                                console.warn("There was an error retriving information about the cart", this, arguments);
                                if (typeof callback === 'function') errorCallback(addToCartResponse);
                                deferred.reject();
                            }
                        );
                    } else {
                        //unsuccessful
                        if (addToCartResponse.requiresSelection && options.showAttributeSelectionModal) {
                            modal.fromURL('/ProductDetailsPopup/' + productId);

                            if (typeof callback === 'function') callback(addToCartResponse);
                            deferred.resolve();
                        } else {
                            if (typeof errorCallback === 'function') errorCallback(addToCartResponse);
                            deferred.reject();
                        }
                    }
                },
                error: function () {
                    if (typeof errorCallback === 'function') errorCallback();
                    deferred.reject();
                }
            });

            return deferred;
        }
    };

    function initialize ($target) {
        setupProductAttributeForm($('.product-details-form', $target));
        setupGallery($('.gallery', $target));
        setupWheelHardware($('[wheel-hardware]'), $target);
        setupTirePackageBuilder($('[tire-packages]', $target));
        setupSpecsTable($('#specs-table', $target));
        setupAddToCartButtons($target);
        setupPricingNotes($('[data-bind-pricing-notes]', $target));
        setupStockNotes($('[data-bind-stock-notes]', $target));
    }

    function getURLQueryParams(queryString) {
        var searchTokens = queryString.split(/[&\?]/);
        var urlParams = {};

        for(var i = 0; i < searchTokens.length; i++) {
            if (searchTokens[i]) {
                var paramTokens = searchTokens[i].split('=');
                urlParams[paramTokens[0].toLowerCase()] = decodeURIComponent(paramTokens[1]);
            }
        }

        return urlParams;
    }
    
    /**
     * @param {string[]} partNumbers 
     * @param {string[]} productIds
     * @returns {JQueryDeferred<[{[partNumber:string]:string},{[productId: string]:string}]>}
     */
    function getStockNotes(partNumbers, productIds) {
        var partNumbersToLookup = [];
        var productIdsToLookup = [];

        var deferred = $.Deferred();

        var i, partNumber, productId;

        for (i = partNumbers.length - 1; i >= 0; i--) {
            partNumber = partNumbers[i];

            if (partNumber in stockNotesCache.partNumbers) continue;

            partNumbersToLookup.push(partNumber);
        }

        for (i = productIds.length - 1; i >= 0; i--) {
            productId = productIds[i];

            if (productId in stockNotesCache.productIds) continue;

            productIdsToLookup.push(productId);
        }

        if (partNumbersToLookup.length === 0 && productIdsToLookup.length === 0) 
            return deferred.resolve([
                stockNotesCache.partNumbers,
                stockNotesCache.productIds
            ]);

        $.post("/Product/GetStockNotes", {partNumbers: partNumbersToLookup, productIds: productIdsToLookup, filteredPartNumbers: window.filteredPartNumbers}, function(response) {
            for (var partNumber in response.PartNumberStockNotes) 
                stockNotesCache.partNumbers[partNumber] = response.PartNumberStockNotes[partNumber];

            for (var productId in response.ProductStockNotes) 
                stockNotesCache.productIds[productId] = response.ProductStockNotes[productId];

            deferred.resolve([
                stockNotesCache.partNumbers,
                stockNotesCache.productIds
            ]);
        }, "json");

        return deferred;
    }

    /**
     * @param {string[]} partNumbers 
     * @param {string[]} productIds
     * @returns {JQueryDeferred<[{[partNumber:string]:string},{[productId: string]:string}]>}
     */
    function getPricingNotes(partNumbers, productIds) {
        var partNumbersToLookup = [];
        var productIdsToLookup = [];

        var deferred = $.Deferred();

        var i, partNumber, productId;

        for (i = partNumbers.length - 1; i >= 0; i--) {
            partNumber = partNumbers[i];

            if (partNumber in pricingNotesCache.partNumbers) continue;

            partNumbersToLookup.push(partNumber);
        }

        for (i = productIds.length - 1; i >= 0; i--) {
            productId = productIds[i];

            if (productId in pricingNotesCache.productIds) continue;

            productIdsToLookup.push(productId);
        }

        if (partNumbersToLookup.length === 0 && productIdsToLookup.length === 0) 
            return deferred.resolve([
                pricingNotesCache.partNumbers,
                pricingNotesCache.productIds
            ]);

        $.post("/Product/GetPricingNotes", {partNumbers: partNumbersToLookup, productIds: productIdsToLookup, filteredPartNumbers: window.filteredPartNumbers}, function(response) {
            for (var partNumber in response.PartNumberPricingNotes) 
                pricingNotesCache.partNumbers[partNumber] = response.PartNumberPricingNotes[partNumber];

            for (var productId in response.ProductPricingNotes) 
                pricingNotesCache.productIds[productId] = response.ProductPricingNotes[productId];

            deferred.resolve([
                pricingNotesCache.partNumbers,
                pricingNotesCache.productIds
            ]);
        }, "json");

        return deferred;
    }

    function setupStockNotes ($stockNoteTargets, partNumber, productId, inline) {
        var partNumbers = [];
        var productIds = [];

        var partNumberLookup = {};
        var productIdLookup = {};

        var addToLookup = function ($target, lookup, key) {
            if (key in lookup) {
                var $old = lookup[key];
                var $spinner = $old.$spinner;
                var $new = $old.add($target);

                $new.$spinner = $spinner.add($target.$spinner);

                lookup[key] = $new;
            } else {
                lookup[key] = $target;
            }
        }

        $stockNoteTargets.each(function () {
            var $target = $(this);

            var targetPartNumber = partNumber || $target.data('partNumber');
            var targetProductId = productId || $target.data('product-id');

            if (!targetPartNumber && !targetProductId) return;

            var $spinner = $('<i/>', {"class": "fas fa-spin fa-spinner"});

            var $stack = $target.find('.fa-stack');

            // Remove the old inline table if it exists
            if (inline === true)
                $target.find('.inline-stock-notes').remove();

            if ($stack.length) $stack.append($spinner.addClass("fa-stack-1x fa-inverse"));
            else $target.append($spinner);

            $target.$spinner = $spinner;

            if (targetPartNumber) {
                addToLookup($target, partNumberLookup, targetPartNumber);
                partNumbers.push(targetPartNumber);
            }
            
            if (targetProductId) {
                addToLookup($target, productIdLookup, targetProductId);
                productIds.push(targetProductId);
            }
        });

        if (!partNumbers.length && !productIds.length) return;

        getStockNotes(partNumbers, productIds)
            .done(function (stockNotes) {
                var partNumberStockNotes = stockNotes[0];
                var productStockNotes = stockNotes[1];

                var setNotes = function (key, elementLookup, notesLookup) {
                    var $target = elementLookup[key];
                    var notes = notesLookup[key];

                    if (!$target) return;

                    if ($target.$spinner) {
                        $target.$spinner.remove();
                        delete $target.$spinner;
                    }

                    if (!notes) return;

                    if (inline === true) {
                        $('<div class="inline-stock-notes mt-1 mb-3 pl-2"><small>' + notes + '</small></div>').appendTo($target);
                    } else {
                        $target
                            .removeAttr('data-original-title')
                            .tooltip({
                                html: true
                            }).data('bs.tooltip').config.title = notes;
                    }
                }

                for (var i = 0; i < partNumbers.length; i++)
                    setNotes(partNumbers[i], partNumberLookup, partNumberStockNotes);

                for (var i = 0; i < productIds.length; i++)
                    setNotes(productIds[i], productIdLookup, productStockNotes);
            });
    }
    
    function setupPricingNotes ($pricingNoteTargets, partNumber, productId) {
        var partNumbers = [];
        var productIds = [];

        var partNumberLookup = {};
        var productIdLookup = {};

        var addToLookup = function ($target, lookup, key) {
            if (key in lookup) {
                var $old = lookup[key];
                var $spinner = $old.$spinner;
                var $new = $old.add($target);

                $new.$spinner = $spinner.add($target.$spinner);

                lookup[key] = $new;
            } else {
                lookup[key] = $target;
            }
        }

        $pricingNoteTargets.each(function () {
            var $target = $(this);

            var targetPartNumber = partNumber || $target.data('partNumber');
            var targetProductId = productId || $target.data('product-id');

            if (!targetPartNumber && !targetProductId) return;

            var $spinner = $('<i/>', {"class": "fas fa-spin fa-spinner"});

            var $stack = $target.find('.fa-stack');

            if ($stack.length) $stack.append($spinner.addClass("fa-stack-1x fa-inverse"));
            else $target.append($spinner);

            $target.$spinner = $spinner;

            if (targetPartNumber) {
                addToLookup($target, partNumberLookup, targetPartNumber);
                partNumbers.push(targetPartNumber);
            }
            
            if (targetProductId) {
                addToLookup($target, productIdLookup, targetProductId);
                productIds.push(targetProductId);
            }
        });

        if (!partNumbers.length && !productIds.length) return;

        getPricingNotes(partNumbers, productIds)
            .done(function (pricingNotes) {
                var partNumberPricingNotes = pricingNotes[0];
                var productPricingNotes = pricingNotes[1];

                var setNotes = function (key, elementLookup, notesLookup) {
                    var $target = elementLookup[key];
                    var notes = notesLookup[key];

                    if (!$target) return;

                    if ($target.$spinner) {
                        $target.$spinner.remove();
                        delete $target.$spinner;
                    }

                    if (!notes) return;

                    $target
                        .removeAttr('data-original-title')
                        .tooltip({
                            html: true
                        }).data('bs.tooltip').config.title = notes;
                }

                for (var i = 0; i < partNumbers.length; i++)
                    setNotes(partNumbers[i], partNumberLookup, partNumberPricingNotes);

                for (var i = 0; i < productIds.length; i++)
                    setNotes(productIds[i], productIdLookup, productPricingNotes);
            });
    }

    function setupAddToCartButtons($target) {
        $target.on('click', '[add-to-cart]', function () {
            var $this = $(this);
            var options = $this.data();

            var $qty = $this.closest('.input-group').find('.qty,.qty-input');

            if ($qty.length) {
                options.quantity = $qty.val();
            } else if ('qty' in options) {
                options.quantity = options.qty;
            }

            $this.prop('disabled', true);

            var addedToCart = products.addToCart(options)
                .always(function () {
                    $this.prop('disabled', false);
                });
            
            if (options.refresh) {
                addedToCart.done(function () {
                    location.reload();
                });
            }
        });
    }

    function setupTirePackageBuilder($tirePackageBuilder) {
        $tirePackageBuilder.each(function (i, vp) {
            new Vue({
                el: vp,
                data: {
                    wheelPartNumber: undefined,
                    tires: []
                },

                computed: {
                    wheelSelected: function () {
                        return !!this.wheelPartNumber;
                    }
                },

                watch: {
                    wheelPartNumber: function (newPartNumber) {
                        if (newPartNumber) {
                            this.loadTires();
                        }
                    }
                },
                
                created: function () {
                    var self = this;

                    this.onProductConfigurationChanged = function (e, configuration) {
                        self.wheelPartNumber = configuration ? configuration.ManufacturerPartNumber : undefined;  
                    };

                    $(document.body).on('product-configuration-selected', this.onProductConfigurationChanged);
                    $(document.body).on('product-configuration-cleared', this.onProductConfigurationChanged)
                },
                destroyed: function () {
                    $(document.body).off('product-configuration-selected product-configuration-cleared', this.onProductConfigurationChanged);
                },

                methods: {
                    loadTires: function () {
                        var data = {
                            wheelPartNumber: this.wheelPartNumber
                        };

                        if (!data.wheelPartNumber) {
                            this.items = [];
                            return;
                        }

                        var self = this;

                        
                        $('[tire-packages] .card').addClass('loading loading-container');

                        $.ajax({
                            url: '/Product/GetTiresForWheelAndVehicle',
                            data: data
                        })
                            .then(
                                function (tires) {
                                    if (tires.error) {
                                        console.error(tires.error);
                                        self.tires = [];
                                    } else {
                                        self.tires = tires.slice(0, 3);
                                    }

                                    $('[tire-packages] .card').removeClass('loading loading-container');
                                }, 
                                function () {
                                    self.tires = [];

                                    $('[tire-packages] .card').removeClass('loading loading-container');
                                }
                            );

                        return undefined;
                    },

                    addToCart: function(item) {
                        products.addToCart({
                            productId: item.productId,
                            partNumber: item.partNumber,
                            quantity: item.cartQuantity,

                            data: {
                                rideStylerCategoryType: 'Tire',
                            }
                        })
                    }
                }
            })
        });
    }

    function setupWheelHardware($wheelHardwareCard) {
        $wheelHardwareCard.each(function (i, vp) {
            var productFields = [
                {
                    key: 'partNumber',
                    label: 'Part#',
                    sortable: true
                },
                {
                    key: 'description',
                    label: 'Description',
                    sortable: false
                },
                {
                    key: 'stock',
                    label: 'Stock',
                    sortable: true,
                    tdClass: function (value) {
                        return value <= 0 ? 'text-danger' : '';
                    }
                },
                {
                    key: 'priceAmount',
                    label: 'Price',
                    sortable: true,
                    formatter: function (value, key, item) {
                        return item.priceDisplay;
                    }
                },
                {
                    key: 'cartQuantity',
                    label: '',
                    sortable: false
                }
            ];

            function loadWheelHardwareTable(url, data, callback, highlightFirstRow) {
                $('[wheel-hardware]').addClass('loading loading-container');

                $.ajax({
                    url: url,
                    data: data
                })
                    .then(
                        function(items) {
                            if (typeof items === 'string') {
                                callback([], items);
                            } else {
                                if (items.length > 0 && highlightFirstRow === true) {
                                    items[0]._rowVariant = 'primary';
                                }

                                callback(items);
                            }
                        }, 
                        function () {
                            callback([]);
                        }
                    )
                    .always(
                        function () {
                            $('[wheel-hardware]').removeClass('loading loading-container');
                        }
                    );
            }

            var ringsTable = function (context, callback) {
                var data = {
                    wheelPartNumber: this.$parent.wheelPartNumber
                };

                if (!data.wheelPartNumber) return [];

                loadWheelHardwareTable('/Product/GetHubRings', data, callback);
            };

            var lugKitTable = function (context, callback) {
                var data = {
                    wheelPartNumber: this.$parent.wheelPartNumber
                };

                if (!data.wheelPartNumber) return [];

                loadWheelHardwareTable('/Product/GetLugKits', data, callback, true);
            };

            var efsKitTable = function (context, callback) {
                var data = {
                    PartNumber: this.$parent.wheelPartNumber
                };

                if (!data.PartNumber) return [];

                loadWheelHardwareTable('/YKW/GetEFSKits', data, callback, true);
            };

            var accessoriesTable = function (context, callback) {
                var data = {
                    PartNumber: this.$parent.wheelPartNumber
                };

                if (!data.PartNumber) return [];

                loadWheelHardwareTable('/Product/GetWheelAccessories', data, callback);
            };

            var viewModel = {
                loading: false,
                wheelPartNumber: undefined,
                fields: productFields,
                message: '',
                items: function (context, callback) {
                    var self = this.$parent;
                    return self.currentTable.call(this, context, function (items, message) {
                        if (!message) message = 'There were no products found for your application.';

                        viewModel.message = message;
                        callback(items); 
                    });
                },

                ringsTable: ringsTable,
                lugKitTable: lugKitTable,
                efsKitTable: efsKitTable,
                accessoriesTable: accessoriesTable,

                currentTable: ringsTable,

                highlightFirstRow: false
            };

            new Vue({ 
                el: vp,
                data: viewModel,
                computed: {
                    wheelSelected: function () {
                        return !!this.wheelPartNumber;
                    }
                },

                watch: {
                    wheelPartNumber: function (newPartNumber) {
                        if (newPartNumber) this.refresh();
                    }
                },
                created: function () {
                    var self = this;

                    this.onProductConfigurationChanged = function (e, configuration) {
                        self.wheelPartNumber = configuration ? configuration.ManufacturerPartNumber : undefined;  
                    };

                    $(document.body).on('product-configuration-selected', this.onProductConfigurationChanged);
                    $(document.body).on('product-configuration-cleared', this.onProductConfigurationChanged)
                },
                destroyed: function () {
                    $(document.body).off('product-configuration-selected product-configuration-cleared', this.onProductConfigurationChanged);
                },
                methods: {
                    addToCart: function(item) {
                        var rsCategory = null;
                        if (this.currentTable === this.efsKitTable)
                            rsCategory = 'CustomInstallKits';
                        else if (this.currentTable === this.lugKitTable)
                            rsCategory = 'LugKit';
                        else if (this.currentTable === this.ringsTable)
                            rsCategory = 'HubRing';
                        else if (this.currentTable === this.accessoriesTable)
                            rsCategory = 'WheelAccessory';

                        products.addToCart({
                            productId: item.productId,
                            partNumber: item.partNumber,
                            quantity: item.cartQuantity,

                            data: {
                                searchRideStylerCategoryType: rsCategory,
                            }
                        })
                    },
                    refresh: function () {
                        var componentReferences = this.$refs; 
                        if (componentReferences.table) componentReferences.table.refresh();
                    },
                    setTable: function (table) {
                        if (this.currentTable === table) return;

                        this.highlightFirstRow = (table == this.lugKitTable || table == this.efsKitTable);
                        this.currentTable = table;
                        this.refresh();
                    }
                }
            });
        });
    }

    function updateCartQuantity(count) {
        $('.cart-quantity').text(count);
    }

    function setupGallery($gallery) {
        $gallery.on('click', '.tile', function() {
            var $tile = $(this);
            var $tileImage = $tile.children('img').first();

            var imageData = $tileImage.data();

            var fullSizeURL = imageData.fullsize;
            var defaultSizeURL = imageData.defaultsize;


            $(imageData.target)
                .prop('src', defaultSizeURL)
                .attr('data-fullsize', fullSizeURL);

            $tile.siblings().removeClass('active');
            $tile.addClass('active');
        });
    }

    /**
     * @param {JQuery<HTMLTableElement>} $allSpecsTables 
     */
    function setupSpecsTable($allSpecsTables) {
        $allSpecsTables.each(function () {
            var $specsTable = $(this);

            $(document.body).on('vehicle-activated', function (e, data) {
                $specsTable
                    .find('#show-no-fit-specs').on('click', function (e) {
                        e.preventDefault();

                        $specsTable.find('tr.no-fit').show();
                        $(this).parent().remove();
                    })
            });
        })
    }
    
    function setupProductAttributeForm($forms) {
        $forms.each(function () {
            var $form = $(this);

            $form.on('click', '.add-to-cart-button', function (e) {
                e.preventDefault();
    
                var $this = $(this);
                var $notesModal = $('#select-attributes-notes-modal');

                var addToCart = function() {
                    products.addToCart({
                        productId: $form.data('productId'),
                        partNumber: $form.data('partnumber'),
                        quantity: $form.find('.qty-input').val()
                    }, function () {
                        $form.closest('.modal').modal('hide');
                    }).always(function () {
                        $this.prop('disabled', false);
                    })
                };

                var notes = $('.select-attributes-notes-container small').text();
                if (notes.length > 0) 
                {
                    $notesModal.find('.notes').text(notes);
                    $notesModal.find('.btn.btn-primary').off('click').one('click', function() {
                        addToCart();
                        $notesModal.modal('hide');
                    });
                    $notesModal.modal('show');
                }
                else
                {
                    $this.prop('disabled', true);
                    addToCart();
                }
            });
        });
        
        $(document.body)
            .one('product-activated', function (e, /** @type {ProductActivatedEvent} */ product) {

                // Don't do anything if there are no product combinations
                if (!product.Combinations || !product.Combinations.length) return;

                /** @type {ProductCombination[]} */
                var combinations = product.Combinations;

                $forms
                    .filter(function () {
                        return $(this).data('productId') === product.ProductId;
                    })
                    .each(function () {
                        var $form = $(this);
                        var $allSelects = getAllSelects($form);

                        /** @returns {{[attributeName:string]:string}} */
                        function getAttributesSelection() {
                            var selection = getAttributesSelectionInternal($allSelects);
                            var returnSelection = {};

                            for (var i = 0; i < selection.pairs.length; i++) {
                                var pair = selection.pairs[i];
                                var attributeMappingID = pair[0];
                                var value = pair[2];
                                var attributeName = product.AttributeMappingIdToName[attributeMappingID];

                                returnSelection[attributeName] = value;
                            }

                            return returnSelection;
                        }

                        /**
                         * @typedef AttributeValueMap
                         * @prop {number} AttributeMappingId
                         * @prop {number[]} ValueIds
                         */

                        /**
                         * @typedef PriceModel 
                         * @prop {number} Price
                         * @prop {string} DisplayedPrice
                         */

                        /**
                         * @typedef ProductCombination
                         * @prop {string} ManufacturerPartNumber
                         * @prop {PriceModel} Price
                         * @prop {number} Stock
                         * @prop {AttributeValueMap[]} AttributeValues
                         */

                        /**
                         * @typedef {[number, number, string, string]} SelectionPair
                         * A pair indicating a selection on a select element: [attributeMappingID, attributeValueID, attributeName, attributeValue]
                         */

                        /**
                         * @typedef ProductActivatedEvent
                         * @prop {number} ProductId
                         * @prop {string[]} VehicleFitPartNumbers
                         * @prop {ProductCombination[]} Combinations
                         * @prop {{[attributeMappingID:string]:string}} AttributeMappingIdToName
                         */

                        /**
                         * @prop {{partNumbers: partNumbers}} VehicleTireOptionID    The ID of the selected VehicleTireOption
                         */

                        /**
                         * Returns all product attribute selects from the form
                         * @param {JQuery} $form The form containing the select elements
                         * @returns {JQuery<HTMLSelectElement>}
                         */
                        function getAllSelects($form) { return $form.find('.attributes select'); }
                        
                        /**
                         * Find categorize attribute select boxes from the $form
                         * @param {JQuery} $form           The form containing the select elements
                         * @param {JQuery} [$lastChangedSelect] The last changed select element
                         */
                        function findSelects($form , $lastChangedSelect) {
                            var $allSelects = getAllSelects($form);

                            var $selects = {
                                all: $allSelects,
                                active: $(),
                                inactive: $(),
                                last: $(),
                                next: $(),
                            };

                            // If the last select that was changed does not have a value and its not locked, the last changed select
                            // is the previous select box in the list
                            if ($lastChangedSelect && !$lastChangedSelect.prop('value')  && !selectIsLocked($lastChangedSelect)) {
                                var lastChangedSelectIndex = $allSelects.index($lastChangedSelect);

                                if (lastChangedSelectIndex > 0) {
                                    $lastChangedSelect = $allSelects.slice(lastChangedSelectIndex - 1, lastChangedSelectIndex);
                                } else {
                                    $lastChangedSelect = undefined;
                                }
                            }

                            if ($lastChangedSelect) {
                                var lastChangedSelectIndex = $allSelects.index($lastChangedSelect);

                                // Active selects are all selects up to and including the last changed select
                                $selects.active = $allSelects.slice(0, lastChangedSelectIndex + 1);

                                // Next select is the select after the one that was last changed
                                $selects.next = $allSelects.slice(lastChangedSelectIndex + 1, lastChangedSelectIndex + 2);

                                // Inactive selects are all of the selects that follow
                                $selects.inactive = $allSelects.slice(lastChangedSelectIndex + 2);

                                $selects.last = $lastChangedSelect;
                            } else {
                                // Next select is the first select
                                $selects.next = $allSelects.first();

                                // Inactive selects are all of the selects that follow
                                $selects.inactive = $allSelects.slice(1);
                            }

                            return $selects;
                        }

                        /**
                         * @param {JQuery} $form 
                         */
                        function setupDropdowns($form) {
                            findSelects($form).all
                                .each(function () {
                                    var $select = $(this);

                                    $select.prepend(
                                        $('<option/>', {
                                            text: '-',
                                            value: '',
                                        })
                                            .addClass('default-option')
                                    );
                                });

                            $form.on('change', '.attributes', function (e) {
                                updateDropdowns($form, $(e.target)); 
                            });
                        }

                        /**
                         * @param {ProductCombination} combo 
                         * @param {number} attributeMappingId 
                         */
                        function findProductAttribute(combo, attributeMappingId) {
                            var attributeValues = combo.AttributeValues;
                            
                            for (var i = 0; i < attributeValues.length; i++) {
                                var attributeValue = attributeValues[i];
                                
                                if (attributeValue.AttributeMappingId === attributeMappingId) {
                                    return attributeValue;
                                }
                            }
                            return undefined;
                        }

                        /**
                         * @param {ProductCombination} combo 
                         * @param {number} attributeMappingId 
                         * @param {number} valueId 
                         */
                        function hasProductAttributeValue(combo, attributeMappingId, valueId) {
                            var attributeValue = findProductAttribute(combo, attributeMappingId);

                            if (attributeValue) {
                                for (var i = 0; i < attributeValue.ValueIds.length; i++) {
                                    if (valueId == attributeValue.ValueIds[i]) {
                                        return true;
                                    }
                                }
                            }

                            return false;
                        }

                        /**
                         * @param {HTMLElement} select 
                         */
                        function getSelectAttributeMappingId(select) {
                            var match = select.name.match(/product_attribute_(\d+)/);

                            if (!match) return;

                            return parseInt(match[1], 10);
                        }

                        /**
                         * @typedef AttributeSelectionData
                         * @prop {SelectionPair[]} pairs
                         * @prop {Object.<number, number>} map
                         */

                        /**
                         * @param {JQuery<HTMLSelectElement>} $selects 
                         * @returns {AttributeSelectionData}
                         */
                        function getAttributesSelectionInternal($selects) {
                            var attributeMappingIDToValueMap = {};
                            var pairs = [];

                            product

                            $selects.each(function () {
                                var select = this;
                                
                                var attributeMappingId = getSelectAttributeMappingId(select);
                                var selectedIndex = select.selectedIndex;

                                if (!attributeMappingId || selectedIndex < 0) return;

                                var selectedOption = select.options[selectedIndex];

                                var attributeValueID = selectedOption.value;
                                var attributeValue = selectedOption.innerText;

                                if (!attributeValueID) return;

                                attributeMappingIDToValueMap[attributeMappingId] = attributeValueID;
                                pairs.push([attributeMappingId, attributeValueID, attributeValue]);
                            });

                            return {
                                map: attributeMappingIDToValueMap,
                                pairs: pairs
                            }
                        }

                        /**
                         * @param {JQuery<HTMLSelectElement>} $allSelects 
                         * @param {ProductCombination} combination 
                         */
                        function selectProductCombination($allSelects, combination, attributeSelectLookup, valueHints) {
                            var attributeValues = combination.AttributeValues;
                            var attributeMappingIDLookup = {};

                            for (var k in attributeSelectLookup) {
                                var attributeData = attributeSelectLookup[k];

                                attributeMappingIDLookup[attributeData.attributeMappingID] = attributeData;
                            }

                            $allSelects.each(function () {
                                var select = this;

                                var attributeMappingId = getSelectAttributeMappingId(select);
                                var attributeMappingData = attributeMappingIDLookup[attributeMappingId];
                                var valueHint = valueHints[attributeMappingData.name];
                                var valueHintId;

                                if ($.isArray(valueHint))  {
                                    valueHint = valueHint.length > 0 ? valueHint[0] : undefined;
                                }

                                if (valueHint) {
                                    

                                    for (var j = 0; j < attributeMappingData.values.length; j++) {
                                        if (valueHint === attributeMappingData.values[j].value) {
                                            valueHintId = attributeMappingData.values[j].id;
                                            
                                            break;
                                        }
                                    }
                                }

                                for (var i = 0; i < attributeValues.length; i++) {
                                    var attributeValue = attributeValues[i];
                                    var valueIds = attributeValue.ValueIds;

                                    if (attributeValue.AttributeMappingId !== attributeMappingId) continue;

                                    if (valueIds.length > 0) {
                                        var valueId;

                                        if (typeof valueHintId !== 'undefined') {
                                            for (var j = 0; j < valueIds.length; j++) {
                                                if (valueIds[j] == valueHintId) {
                                                    valueId = valueHintId;
                                                    break;
                                                }
                                            }
                                        } 
                                        
                                        if (typeof valueId === 'undefined') valueId = valueIds[0];

                                        select.value = valueId;
                                    }

                                    break;
                                }
                            });
                        }

                        /**
                         * @param {ProductCombination[]} combinations 
                         * @param {SelectionPair[]} selectedValuePairs 
                         */
                        function filterCombinationsToSelection(combinations, selectedValuePairs) {
                            var filteredCombinations = [];

                            // Build filteredCombinations
                            for (var i = 0; i < combinations.length; i++) {
                                var combo = combinations[i];

                                var matches = true;
                                
                                // A combo must match each selected value pair to be added to filteredCombinations
                                for (var j = 0; j < selectedValuePairs.length; j++) {
                                    var pair = selectedValuePairs[j];
                                    
                                    if (!hasProductAttributeValue(combo, pair[0], pair[1])) {
                                        matches = false;
                                        break;
                                    }
                                }

                                if (matches) filteredCombinations.push(combo);
                            }

                            return filteredCombinations;
                        }

                        /**
                         * @param {ProductCombination[]} combinations 
                         * @param {number} attributeMappingId 
                         */
                        function getAllValueIDsMatchingAttributeMappingId(combinations, attributeMappingId) {
                            var valueIDs = [];

                            for (var i = 0; i < combinations.length; i++) {
                                var combo = combinations[i];
                                var productAttributeValues = findProductAttribute(combo, attributeMappingId);

                                if (productAttributeValues) {
                                    for (var k = 0; k < productAttributeValues.ValueIds.length; k++) {
                                        var valueId = productAttributeValues.ValueIds[k];
                                        
                                        if (valueIDs.indexOf(valueId) < 0) valueIDs.push(valueId);
                                    }
                                }
                            }

                            return valueIDs;
                        }

                        /**
                         * @param {ProductCombination[]} combinations 
                         * @param {SelectionPair[]} selectedValuePairs 
                         */
                        function findSelectedCombination(combinations, selectedValuePairs) {
                            for (var i = 0; i < combinations.length; i++) {
                                var combo = combinations[i];
                                
                                var selected = true;

                                // In order for a combination to be selected every selected value pair must be represented in the combination
                                for (var j = 0; j < selectedValuePairs.length; j++) {
                                    var pair = selectedValuePairs[j];
                                    
                                    if (!hasProductAttributeValue(combo, pair[0], pair[1])) {
                                        selected = false;
                                        break;
                                    }
                                }

                                if (selected) {
                                    return combo;
                                }
                            }

                            return undefined;
                        }

                        /**
                         * @param {JQuery<HTMLSelectElement>} $select 
                         */
                        function selectShouldAutoComplete($select) {
                            if (selectIsLocked($select)) return true;

                            var enabledOptionCount = 0;

                            $select.children().each(function () {
                                if (!this.value) return;
                                if (this.disabled) return;

                                enabledOptionCount++;
                            });

                            return enabledOptionCount === 1;
                        }

                        /**
                         * Returns whether or not a select (or its container) is locked
                         * @param {JQuery} $selectOrSelectContainer 
                         */
                        function selectIsLocked($selectOrSelectContainer) {
                            var $selectContainer = $selectOrSelectContainer;

                            if ($selectOrSelectContainer.is('select')) $selectContainer = $selectOrSelectContainer.parent();

                            return $selectContainer.find('.locked-overlay').length > 0;
                        }

                        /**
                         * Called when a valid combination has been unselected
                         * @param {JQuery} $form The product attribute form
                         */
                        function onProductAttributeSelectionCleared($form) {
                            var event = $.Event('product-configuration-cleared');

                            $form
                                .find('.display-product-part-number').text("").end()
                                .find('.select-attributes-instruction-container').show().end()
                                .find('.request-product-pricing-container').hide().end()
                                .find('.product-pricing-container').hide().end()
                                .find('.display-product-price').text('').end()
                                .find('.add-to-cart-button').prop('disabled', true).end();
                            
                            $(document.body).trigger(event);

                            updateStock(undefined);
                        }

                        /**
                         * @param {jQuery<HTMLSelectElement>} $allSelects 
                         * @param {ProductCombination[]} allCombinations 
                         */
                        function disableNonSelectableOptions($allSelects, allCombinations) {
                            /**
                             * @type {SelectionPair[]}
                             */
                            var selectedValuePairs = [];
                            var filteredCombinations = allCombinations;

                            $allSelects.each(function (i, select) {
                                var attributeMappingId = getSelectAttributeMappingId(select);
                                var $select = $(select);

                                // If it doesnt have an attribute ID for some reason, skip it
                                if (!attributeMappingId) return;

                                if (i > 0) {
                                    // Get a list of allowable value IDs for this select box
                                    var validValueIds = getAllValueIDsMatchingAttributeMappingId(filteredCombinations, attributeMappingId);

                                    // Disable/enable options based on whether or not they appear in the validValueIds list
                                    $select.children('option').each(function () {
                                        var option = this; 
                                        var value = option.value;

                                        if (!value) return;

                                        var found = false;

                                        for (var i = 0; i < validValueIds.length; i++) {
                                            var validValueId = validValueIds[i];
                                            
                                            if (validValueId == value) {
                                                found = true;
                                                break;
                                            }
                                        }

                                        option.disabled = !found;
                                    });
                                }

                                var selectionValuePair = getAttributesSelectionInternal($select).pairs[0];

                                if (selectionValuePair) {
                                    selectedValuePairs.push(selectionValuePair);
                                    filteredCombinations = filterCombinationsToSelection(filteredCombinations, selectedValuePairs);
                                } 
                            });
                        }
                        
                        /**
                        * @param {{[attributeName:string]:string}} selection
                        */
                        function updateProductIcons(selection) {
                            $('.product-icon-container').html(
                                $.map(iconDefinitions, function (icon) {
                                    if (!icon.match(selection)) return undefined;

                                    return $('<i/>', {
                                        "class": "fa fa-2x mr-2 " + icon.icon
                                    });
                                })
                            );
                        }

                        /**
                        * Trigger a product selected event
                        * @param {ProductCombination} selectedCombo The selected combo
                        * @param {JQuery} $form The product attribute form
                        * @param {{[attributeName:string]:string}} selection
                        */

                        function onProductAttributeSelected(selectedCombo, $form, selection) {
                            $form
                                .data('partnumber', selectedCombo.ManufacturerPartNumber)
                                .find('.display-product-part-number').text(selectedCombo.ManufacturerPartNumber).end()
                                .find('.display-sku').text(selectedCombo.Sku).end()
                                .find('.select-attributes-instruction-container').hide().end()
                                .find('.add-to-cart-button').prop('disabled', false).end();
                            if (selectedCombo.ManufacturerPartNumber) {
                                var skuDisplay = $form.find('.display-sku');
                                skuDisplay.addClass("d-none");
                                skuDisplay.parent("div").addClass("d-none");
                            } else {
                                var skuDisplay = $form.find('.display-product-part-number');
                                skuDisplay.addClass("d-none");
                                skuDisplay.parent("div").addClass("d-none");
                            }
                            if (selectedCombo.Price && selectedCombo.Price.Price) {
                                $form
                                    .find('.product-pricing-container').show().each(function () {
                                        setupPricingNotes($(this), selectedCombo.ManufacturerPartNumber)
                                    }).end()
                                    .find('.request-product-pricing-container').hide().end()
                                    .find('.display-product-price').text(selectedCombo.Price.DisplayedPrice).end();
                            } else {
                                $form
                                    .find('.request-product-pricing-container').show().each(function () {
                                        setupPricingNotes($(this), selectedCombo.ManufacturerPartNumber)
                                    }).end()
                                    .find('.product-pricing-container').hide().end()
                                    .find('.display-product-price').text('').end();
                            }

                            updateStock(selectedCombo);
                            updateNotes($form, selectedCombo);

                            var event = $.Event('product-configuration-selected');

                            event.selectedCombination = selectedCombo;
                            event.selection = selection;

                            // Store a copy of our selection for reference later
                            var productSelection = $.extend({}, selection);
                            productSelection.url = window.location.href;
                            sessionStorage.lastProductDetailsSelection = JSON.stringify(productSelection);

                            updateProductIcons(selection);
                            
                            $(document.body).trigger(event, [selectedCombo, selection]);
                        }

                        /**
                        * @param {JQuery} $form
                        * @param {ProductCombination} combo 
                        */
                        function updateNotes($form, combo) {
                            var $notesContainer = $('.select-attributes-notes-container', $form).hide();
                            var $notesText = $('small', $notesContainer);

                            $.post('/Product/GetFitmentNotes', {partNumbers: [combo.ManufacturerPartNumber]}, function (response) {
                                var notes = response.Notes[combo.ManufacturerPartNumber];

                                if (!notes || !notes.length) return;

                                $notesText.html(notes[0]);
                                $notesContainer.show();
                            });
                        }

                        /**
                        * @param {JQuery} $form 
                        * @param {JQuery} $target 
                        */
                        function updateDropdowns($form, $target) {
                            try {
                                var $selects = findSelects($form, $target);

                                // Enable the next select box in the list
                                $selects.next.prop('disabled', false);

                                // Disable the select boxes after the next box
                                $selects.inactive.prop('disabled', true);

                                // Reset the next & inactive select boxes to their default option
                                $selects.next.add($selects.inactive).val('');

                                var selection = getAttributesSelectionInternal($selects.all);

                                var filteredCombinations = filterCombinationsToSelection(combinations, selection.pairs);
                                
                                // Filter the allowed selectable options
                                disableNonSelectableOptions($selects.all, combinations);

                                if (selectShouldAutoComplete($selects.next)) {
                                    $selects.next.children(':enabled').last().prop('selected', true);
                                    updateDropdowns($form, $selects.next);
                                    return;
                                }

                                var hasMadeEnoughSelections = selection.pairs.length === $selects.all.length;
                                var selectedCombo = hasMadeEnoughSelections && findSelectedCombination(filteredCombinations, selection.pairs);

                                if (selectedCombo) {
                                    onProductAttributeSelected(selectedCombo, $form, getAttributesSelection());
                                } else {
                                    $selects.next.focus();
                                    onProductAttributeSelectionCleared($form);
                                }
                            } catch(e) {
                                onProductAttributeSelectionCleared($form);
                                throw e;
                            }
                        }

                        /**
                        * @param {ProductCombination} combo
                        */
                        var updateStock = function (combo) {};

                        var $stockDisplay = $form.find('.product-stock-display');

                        if ($stockDisplay.length) {
                            var stockVue = new Vue({
                                el: $stockDisplay[0],
                                data: {
                                    stock: 0,
                                    hidden: true
                                }
                            });

                            updateStock = function updateStock (combo) {
                                if (combo) {
                                    var stock = combo.Stock;

                                    stockVue.stock = stock;
                                    stockVue.hidden = false;
                                    
                                    setupStockNotes($form.find('.product-stock-display'), combo.ManufacturerPartNumber, null, true);
                                } else {
                                    stockVue.hidden = true;
                                }
                            };
                        }

                        setupDropdowns($form);

                        var vehicleBoltPatternId, vehicleCenterboreId, vehicleDiameterIds = [], vehicleTireSizeID;

                        vehicleActivatedPromise.done(function (vehicleSelection, vehicleDescription, fitmentProfile) {
                            var attributeSelectLookup = {};
                            var allAttributeSelectValues = [];

                            // Generate attributeSelectLookup
                            $allSelects.each(function () {
                                var select = this;
                                var $select = $(select);
                                var attributeMappingID = getSelectAttributeMappingId(select);
                                var attributeName = product.AttributeMappingIdToName[attributeMappingID];
                                var values = $select.children().not('.default-option').map(function () {
                                    return {
                                        name: attributeName,
                                        value: this.text,
                                        id: parseInt(this.value, 10)
                                    };
                                }).get();

                                allAttributeSelectValues = allAttributeSelectValues.concat(values);

                                attributeSelectLookup[attributeName] = {
                                    $select: $select,
                                    name: attributeName,
                                    attributeMappingID: attributeMappingID,
                                    values: values
                                };
                            });

                            var findAllAttributeValueIDsSatisfying = function (attributeValues, filter) {
                                var ids = [];

                                for (var i = 0; i < attributeValues.length; i++) {
                                    var value = attributeValues[i].value;
                                    var id = attributeValues[i].id;
                                    var name = attributeValues[i].name;

                                    if (filter(value, id, name)) ids.push(id);
                                }

                                return ids;
                            };

                            var findFirstAttributeValueIDSatisfying = function (attributeValues, filter) {
                                for (var i = 0; i < attributeValues.length; i++) {
                                    var value = attributeValues[i].value;
                                    var id = attributeValues[i].id;

                                    if (filter(value, id)) return id;
                                }

                                return undefined;
                            };

                            var findClosestAttributeValueID = function (attributeValues, valueOrValues) {
                                var values;

                                if (!valueOrValues) return undefined;

                                if ($.isArray(valueOrValues)) values = valueOrValues;
                                else values = [valueOrValues];

                                var minDistance = Infinity;
                                var bestId = undefined;
                                
                                for (var i = 0; i < attributeValues.length; i++) {
                                    var value = attributeValues[i].value;
                                    var id = attributeValues[i].id;
                                    var minValueDistance = Infinity;

                                    for (var j = 0; j < values.length; j++) {
                                        var distance = Math.abs(values[j] - value);

                                        if (distance < minValueDistance) {
                                            minValueDistance = distance;
                                        }
                                    }

                                    if (minValueDistance < minDistance) {
                                        minDistance = minValueDistance;
                                        bestId = id;
                                    }
                                }

                                return bestId;
                            }

                            if (vehicleSelection.VehicleConfigurationID) {
                                var boltPatternSelect = attributeSelectLookup["Bolt Pattern"];
                                if (boltPatternSelect) {
                                    var $boltPatternSelect = boltPatternSelect.$select;
                                    
                                    // Lock the select
                                    $boltPatternSelect
                                        .prop('disabled', true)
                                        .children('.default-option').remove();

                                    // Add the locked overlay & tooltip
                                    $('<div/>', {
                                        'class': 'locked-overlay form-control',
                                        'append': [
                                            $('<i/>', {
                                                'class': 'far fa-lock mr-1',
                                            }),
                                            'Locked to selected vehicle'
                                        ],
                                        'appendTo': $boltPatternSelect.parent().addClass('position-relative')
                                    }).tooltip({
                                        html: true,
                                        trigger: 'click',
                                        title: $('<div/>', {
                                            append: [
                                                'We have selected the bolt pattern based off of your vehicle. Clear your vehicle selection to see all options. <span class="text-smaller">(Click again to hide)</span>',
                                                $('<button/>', {
                                                    'class': 'btn btn-primary btn-block mt-2 clear-vehicle-button',
                                                    'text': 'Clear Vehicle',
                                                    'click': function () {
                                                        vehicle.clear(function () {
                                                            location.reload();
                                                        });
                                                    }
                                                })
                                            ]
                                        })
                                    });

                                    if (fitmentProfile) {
                                        var vehicleBoltPattern = fitmentProfile.BoltPatternDesc.toLowerCase();

                                        vehicleBoltPatternId = findFirstAttributeValueIDSatisfying(boltPatternSelect.values, function (value) {
                                            return vehicleBoltPattern === value.toLowerCase();
                                        });
                                    }
                                }

                                var vehicleHub = false;
                                var centerboreSelect = attributeSelectLookup["Centerbore"];
                                if (centerboreSelect && fitmentProfile) {
                                    var vehicleHubs = (function () {
                                        var hubs = {};

                                        for (var i = 0; i < fitmentProfile.RangesRear.length; i++) {
                                            hubs[fitmentProfile.RangesRear[i].VehicleFitmentHub] = true;
                                        }
                                        
                                        for (var i = 0; i < fitmentProfile.RangesFront.length; i++) {
                                            hubs[fitmentProfile.RangesFront[i].VehicleFitmentHub] = true;
                                        }

                                        // Get unique hubs
                                        return Object.keys(hubs);
                                    })();

                                    if (vehicleHubs.length > 0) 
                                        vehicleHub = parseFloat(vehicleHubs[0]);
                                   
                                    vehicleCenterboreId = findClosestAttributeValueID(centerboreSelect.values, vehicleHubs);
                                }

                                var diameterSelect = attributeSelectLookup["Diameter"];
                                if (diameterSelect && fitmentProfile) {
                                    var vehicleFrontDiameter = fitmentProfile.TireOption.Front.InsideDiameter,
                                        vehicleRearDiameter = fitmentProfile.TireOption.Rear.InsideDiameter;

                                    vehicleDiameterIds = findAllAttributeValueIDsSatisfying(diameterSelect.values, function (value) {
                                        return value == vehicleFrontDiameter || value == vehicleRearDiameter
                                    });
                                }

                                var sizeSelect = attributeSelectLookup["Size"];
                                if (sizeSelect && fitmentProfile) {
                                    var frontSize = fitmentProfile.TireOption.Front.Description;
                                    var rearSize = fitmentProfile.TireOption.Rear.Description;

                                    /**
                                     * @param {string} a 
                                     * @param {string} b 
                                     */
                                    var tireSizesMatch = function (a, b) {
                                        a = a.toLowerCase();
                                        b = b.toLowerCase();
                                        
                                        return a.indexOf(b) >= 0 || b.indexOf(a) >= 0;
                                    };

                                    vehicleTireSizeID = findFirstAttributeValueIDSatisfying(sizeSelect.values, function (value) {
                                        return tireSizesMatch(value, frontSize) || tireSizesMatch(value, rearSize);
                                    });
                                }
                            }

                            // Trigger the selected combination
                            {
                                // Load a valid combination for the vehicle
                                var vehicleFitPartNumbers = product.VehicleFitPartNumbers;
                                var vehicleCombos = combinations.filter(function (combination) {
                                    var partNumber = combination.ManufacturerPartNumber;

                                    if (vehicleFitPartNumbers) return vehicleFitPartNumbers.indexOf(partNumber) > -1;
                                    else return partNumber;
                                });

                                // Sort the combinations
                                {
                                    /** @type {((a:ProductCombination,b:ProductCombination)=>number)[]} */
                                    var sorts = [];

                                    var referrerSelectedFiltersPage;
                                    var referrerSelectedFilters = (function () {
                                        var allLastSelectedFilters = filters.lastSelectedFilters();
                                        var currentPage = filters.currentPageToken;
                                        
                                        var returnFilters;

                                        if (typeof(allLastSelectedFilters) != 'undefined')
                                        {
                                            if (currentPage in allLastSelectedFilters) {
                                                returnFilters = allLastSelectedFilters[currentPage];
                                                referrerSelectedFiltersPage = currentPage;
                                            } else {
                                                var referrer = document.referrer.toLowerCase();
                                                var currentOrigin = location.origin.toLowerCase();
                                                
                                                // The referrer is from the same domain
                                                if (referrer.substr(0, currentOrigin.length) === currentOrigin) {
                                                    referrer = referrer.substr(currentOrigin.length);
                                                    referrer = referrer.split('?');

                                                    var referrerPage = referrer[0];
                                                        referrerPage = referrerPage.split("/");
                                                        referrerPage = referrerPage[referrerPage.length - 1];
                                                    
                                                    var referrerQuery = getURLQueryParams(referrer[1] || '');

                                                    if (referrerPage === 'search') {
                                                        returnFilters = {
                                                            search: referrerQuery.q || referrerQuery.search
                                                        };
                                                    } else {
                                                        returnFilters = allLastSelectedFilters[referrerPage];
                                                    }

                                                    referrerSelectedFiltersPage = referrerPage;
                                                }
                                            }
                                        }
                                       
                                        return returnFilters || {};
                                    })();

                                    /**
                                     * @param {ProductCombination} combo 
                                     * @param {string} attributeName 
                                     * @param {number} attributeValueID 
                                     */
                                    var comboContainsValue = function (combo, attributeName, attributeValueID) {
                                        for (var i = 0; i < combo.AttributeValues.length; i++) {
                                            var attributeValue = combo.AttributeValues[i];
                                            if (!attributeName || attributeName === product.AttributeMappingIdToName[attributeValue.AttributeMappingId]) {
                                                return attributeValue.ValueIds.indexOf(attributeValueID) >= 0;
                                            }
                                        }

                                        return false;
                                    };

                                    /**
                                     * @param {ProductCombination} combo 
                                     * @param {string} attributeName 
                                     * @param {number[]} attributeValueIDs 
                                     */
                                    var comboContainsAnyValue = function(combo, attributeName, attributeValueIDs) {
                                        for (var i = 0; i < attributeValueIDs.length; i++) {
                                            if (comboContainsValue(combo, attributeName, attributeValueIDs[i]))
                                                return true;
                                        }

                                        return false;
                                    };

                                    var sizeMatch = /([0-9\.]+)[\/x]([0-9\.]+)[a-z]{1,2}([0-9]+)/i;

                                    /**
                                     * The search from the last page
                                     * @type {string}
                                     */
                                    var referrerSearch;

                                    for (var k in referrerSelectedFilters) {
                                        if (k.toLowerCase() === 'search') {
                                            referrerSearch = referrerSelectedFilters[k];
                                            
                                            if ($.isArray(referrerSearch)) referrerSearch = referrerSearch[0]

                                            referrerSearch = referrerSearch.toLowerCase();
                                            break;
                                        }
                                    }
                                   
                                    // Sort by referrer part number search
                                    if (referrerSearch) {
                                        var referrerSearchSanitized = referrerSearch.replace(/\+/g, ' ');
                                        var searchTireSizeMatch = referrerSearchSanitized.match(sizeMatch);
                                        
                                        var searchMatchingAttributeIDs = findAllAttributeValueIDsSatisfying(allAttributeSelectValues, function (value, id, name) {
                                            if (value.toLowerCase().indexOf(referrerSearchSanitized) >= 0) return true;

                                            if (searchTireSizeMatch && name.toLowerCase() === 'size') {
                                                var valueTireSizeMatch = value.match(sizeMatch);
                                                
                                                if (valueTireSizeMatch && valueTireSizeMatch[1] == searchTireSizeMatch[1] && valueTireSizeMatch[2] == searchTireSizeMatch[2] && valueTireSizeMatch[3] === searchTireSizeMatch[3])
                                                    return true;
                                            }

                                            return false;
                                        });

                                        /**
                                         * Determines whether or not the part number matches 
                                         * the referrer search
                                         * @param {string} partNumber 
                                         */
                                        var partNumberMatchesSearch = function (partNumber) {
                                            if (!partNumber) return false;

                                            partNumber = partNumber.toLowerCase();

                                            return partNumber === referrerSearch || partNumber === referrerSearchSanitized;
                                        };

                                        // Sort product combinations matching the search to the top
                                        sorts.push(function (a, b) {
                                            var aMatchesSearch = partNumberMatchesSearch(a.ManufacturerPartNumber) || comboContainsAnyValue(a, undefined, searchMatchingAttributeIDs);
                                            var bMatchesSearch = partNumberMatchesSearch(b.ManufacturerPartNumber) || comboContainsAnyValue(b, undefined, searchMatchingAttributeIDs);

                                            return bMatchesSearch - aMatchesSearch;
                                        });

                                        delete referrerSelectedFilters.search;
                                    }

                                    var urlParams = getURLQueryParams(window.location.search);
                                    var diameterOverride = (function () {
                                        if (window.addToCartDiameterOverride) return window.addToCartDiameterOverride;
                                        if ('diameter' in urlParams) return parseInt(urlParams['diameter'], 10) || undefined;
                                        return undefined;
                                    })();

                                    /** @type {{[attributeName:string]:string}} */
                                    var sessionSelectedFilters = (function () {
                                        try {
                                            var lastProductDetailsSelection = sessionStorage.lastProductDetailsSelection;
                            
                                            if (typeof lastProductDetailsSelection === 'string') {
                                                lastProductDetailsSelection = JSON.parse(lastProductDetailsSelection);
                                                if (window.location.href == lastProductDetailsSelection.url)
                                                    return lastProductDetailsSelection;
                                            }
                                        } catch(e) {}
                            
                                        return {};
                                    })();

                                    if (vehicleBoltPatternId) {
                                        sorts.push(function (a, b) {
                                            var aHasBoltPattern = comboContainsValue(a, "Bolt Pattern", vehicleBoltPatternId);
                                            var bHasBoltPattern = comboContainsValue(b, "Bolt Pattern", vehicleBoltPatternId);

                                            // Return combinations that match our vehicle's bolt pattern first
                                            return bHasBoltPattern - aHasBoltPattern;
                                        });
                                    }

                                    // Diameter
                                    {
                                        var sortDiameterIds = [];
                                        var diameterSelect = attributeSelectLookup["Diameter"];

                                        if (diameterSelect) {
                                            if (diameterOverride) {
                                                sortDiameterIds.push(findClosestAttributeValueID(diameterSelect.values, diameterOverride));
                                            } else if ("Diameter" in referrerSelectedFilters || "Diameter" in sessionSelectedFilters) {
                                                var sortDiameterValues = referrerSelectedFilters["Diameter"] || [ sessionSelectedFilters["Diameter"] ];
                                                sortDiameterIds = findAllAttributeValueIDsSatisfying(diameterSelect.values, function (value) {
                                                    for (var i = 0; i < sortDiameterValues.length; i++) {
                                                        if (value == sortDiameterValues[i]) return true;
                                                    }
                                                    return false;
                                                });

                                                // Remove it from referrer/session filters since we're already handling it
                                                delete referrerSelectedFilters['Diameter'];
                                                delete sessionSelectedFilters['Diameter']
                                            }                                      
                                        }
                                        
                                        if (sortDiameterIds.length) {
                                            sorts.push(function (a, b) {
                                                var aHasAnyDiameter = comboContainsAnyValue(a, "Diameter", sortDiameterIds);
                                                var bHasAnyDiameter = comboContainsAnyValue(b, "Diameter", sortDiameterIds);

                                                // Return combinations that match our vehicle's tire's inside diameter first
                                                return bHasAnyDiameter - aHasAnyDiameter;
                                            });
                                        }
                                    }

                                    // Tire size
                                    if (referrerSelectedFiltersPage === 'tires' && referrerSelectedFilters['Size']) {
                                        var sizeSelect = attributeSelectLookup['Size'];

                                        if (sizeSelect) {
                                            var filterSizes = [];

                                            for (var i = 0; i < referrerSelectedFilters['Size'].length; i++) {
                                                var s = referrerSelectedFilters['Size'][i].match(sizeMatch);

                                                if (s) filterSizes.push(s);
                                            }

                                            if (filterSizes.length) {
                                                var sortSizeIds = findAllAttributeValueIDsSatisfying(sizeSelect.values, function (value) {
                                                    value = value.match(sizeMatch);

                                                    if (!value) return;

                                                    for (var i = 0; i < filterSizes.length; i++) {
                                                        if (value[1] == filterSizes[i][1] && value[2] == filterSizes[i][2] && value[3] == filterSizes[i][3])
                                                            return true;
                                                    }
                                                    return false;
                                                });

                                                delete referrerSelectedFilters['Size'];

                                                if (sortSizeIds.length) {
                                                    sorts.push(function (a, b) {
                                                        var aHasAnySize = comboContainsAnyValue(a, "Size", sortSizeIds);
                                                        var bHasAnySize = comboContainsAnyValue(b, "Size", sortSizeIds);
        
                                                        // Return combinations that match our vehicle's tire's inside Size first
                                                        return bHasAnySize - aHasAnySize;
                                                    });
                                                }
                                            }
                                        }
                                    } else if (vehicleTireSizeID) {
                                        sorts.push(function (a, b) {
                                            var aHasTireSize = comboContainsValue(a, "Size", vehicleTireSizeID);
                                            var bHasTireSize = comboContainsValue(b, "Size", vehicleTireSizeID);

                                            // Return combinations that match our vehicle's tire size first
                                            return bHasTireSize - aHasTireSize;
                                        });
                                    }

                                    /**
                                     * @param {string} matchFilterName 
                                     * @param {string[]} matchValues 
                                     */
                                    function addSort(matchFilterName, matchValues) {
                                        var attributeSelect = attributeSelectLookup[matchFilterName];

                                        // No attribute select for this filter found
                                        if (!attributeSelect) return;

                                        var ids = findAllAttributeValueIDsSatisfying(attributeSelect.values, function (value) {
                                            for (var i = 0; i < matchValues.length; i++) {
                                                if (value == matchValues[i]) return true;
                                            }
                                            return false;
                                        });

                                        if (ids.length) {
                                            sorts.push(function (a, b) {
                                                var aHasAny = comboContainsAnyValue(a, matchFilterName, ids);
                                                var bHasAny = comboContainsAnyValue(b, matchFilterName, ids);

                                                // Return combinations that match our filter first
                                                return bHasAny - aHasAny;
                                            });
                                        }
                                    }

                                    var hasAppliedCenterboreSort = false;
                                    function createCenterboreSort() {
                                        if (!vehicleHub || hasAppliedCenterboreSort) return;

                                        var attributeSelect = attributeSelectLookup['Centerbore'];

                                        // No attribute select for this filter found
                                        if (!attributeSelect) return;

                                        var ids = findAllAttributeValueIDsSatisfying(attributeSelect.values, function (value) {
                                            var centerBore = parseFloat(value);
                                            var difference = Math.abs(vehicleHub - centerBore);

                                            if (difference < 0.09) return true;
                                            return false;
                                        });

                                        sorts.push(function(a, b) {
                                            var aHasAny = comboContainsAnyValue(a, 'Centerbore', ids);
                                            var bHasAny = comboContainsAnyValue(b, 'Centerbore', ids);

                                            // Return combinations that match our filter first
                                            return bHasAny - aHasAny;
                                        });

                                        hasAppliedCenterboreSort = true;
                                    }

                                    // Go through the rest of the referrer filters and apply them 
                                    for (var filterName in referrerSelectedFilters) 
                                        addSort(filterName, referrerSelectedFilters[filterName]);

                                    // If the user searched for OE Hub results then we apply our centerbore sort earlier
                                    if ('OE Hub' in referrerSelectedFilters) {
                                        createCenterboreSort();
                                    }

                                    // Go through the session filters and apply them
                                    for (var filterName in sessionSelectedFilters)
                                        addSort(filterName, [sessionSelectedFilters[filterName]]);


                                    // Sort by stock availabilty (desc)
                                    sorts.push(function (a,b) {
                                        var aHasStock = a.Stock >= 4;
                                        var bHasStock = b.Stock >= 4;

                                        return bHasStock - aHasStock;
                                    });

                                    // We sort to default to OE hub if we don't have any other sorts that are better
                                    // NOTE: If the user filters on OE Hub we apply this sort earlier (See above)
                                    createCenterboreSort();

                                    // Sort based on OE diameter replacement
                                    if (vehicleDiameterIds.length) {
                                        sorts.push(function (a, b) {
                                            var aHasAnyDiameter = comboContainsAnyValue(a, "Diameter", vehicleDiameterIds);
                                            var bHasAnyDiameter = comboContainsAnyValue(b, "Diameter", vehicleDiameterIds);

                                            // Return combinations that match our vehicle's tire's inside diameter first
                                            return bHasAnyDiameter - aHasAnyDiameter;
                                        });
                                    }

                                    vehicleCombos.sort(function (a, b) {
                                        var s;
                                        for (var i = 0; i < sorts.length; i++) {
                                            s = sorts[i](a,b);

                                            if (s !== 0) break;
                                        }

                                        return s;
                                    });
                                }

                                var selectedCombo = vehicleCombos.length && vehicleCombos[0];

                                // Use the filtered vehicle combinations instead of the full list of combinations
                                combinations = vehicleCombos;
                                
                                if (selectedCombo) {
                                    selectProductCombination($allSelects, selectedCombo, attributeSelectLookup, $.extend({}, sessionSelectedFilters, referrerSelectedFilters));
                                    disableNonSelectableOptions($allSelects, combinations);
                                    onProductAttributeSelected(selectedCombo, $form, getAttributesSelection());
                                }
                            }

                            $form.parent().removeClass('loading');
                        });
                    });
            });
    }
}();